// File Metadata:
// Filename: Login.js
// Version: 1.00
// Created: 2022-08-23 21:01:42
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useRef, useState, useEffect } from 'react'
import { useNavigate, Link, useLocation } from 'react-router-dom' // Add useLocation
import { useDispatch } from 'react-redux'
import { setCredentials } from './authSlice'
import { useLoginMutation } from '../api/authApiSlice'
import usePersist from '../../hooks/usePersist'
import { tokenService } from '../../services/tokenService' // Add tokenService import
import './Login.css'
import {
	Button,
	FilledInput,
	FormControl,
	FormLabel,
	Icon,
	IconButton,
	Input,
	InputAdornment,
	InputLabel,
	TextField,
	Typography,
	Card,
	CardHeader,
	Avatar,
	CardContent,
	Alert
} from '@mui/material'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import AccountCircle from '@mui/icons-material/AccountCircle'

const Login = () => {
	const userRef = useRef()
	const errRef = useRef()
	const navigate = useNavigate()
	const location = useLocation() // Add location hook
	const from = location.state?.from?.pathname || "/dash" // Define from with fallback

	const [username, setUsername] = useState('')
	const [password, setPassword] = useState('')
	const [showPassword, setShowPassword] = useState(false)
	const [errMsg, setErrMsg] = useState('')
	const [persist, setPersist] = usePersist()

	const dispatch = useDispatch()

	const [login, { isLoading }] = useLoginMutation()

	useEffect(() => {
		userRef.current.focus()
	}, [])
	useEffect(() => {
		setErrMsg('')
	}, [username, password])

	const handleSubmit = async e => {
		e.preventDefault()
		try {
			// Get response from login endpoint
			const response = await login({ username, password }).unwrap()
			console.log('Login response:', response)

			// Store full response in Redux
			dispatch(setCredentials(response))

			// Clear error message
			setErrMsg('')
			
			// Force navigation to dash
			navigate('/dash', { replace: true })
		} catch (err) {
			console.error('Login failed:', err)
			if (!err.status) {
				setErrMsg('No Server Response')
			} else if (err.status === 400) {
				setErrMsg('Missing Username or Password')
			} else if (err.status === 401) {
				setErrMsg('Unauthorized')
			} else {
				setErrMsg(err.data?.message || 'Login Failed')
			}
			errRef.current.focus()
		}
	}

	const handleUserInput = e => setUsername(e.target.value)
	const handlePwdInput = e => setPassword(e.target.value)
	const handleShowPassword = e => setShowPassword(prev => !prev)
	const handleMouseDownPassword = e => {
		e.preventDefault()
	}
	const handleToggle = () => setPersist(prev => !prev)

	const errClass = errMsg ? 'errmsg' : 'offscreen'

	if (isLoading) return <p>Loading ...</p>

	const content = (
		<Card sx={{ maxWidth: 345, boxShadow: 2, margin: 2 }}>
			<CardHeader title='Welcome' subheader='Sign In to your dashboard' />
			<CardContent>
				<Alert severity='error' ref={errRef} className={errMsg ? 'errmsg' : 'offscreen'} aria-live='assertive'>
					{errMsg}
				</Alert>
				<FormControl margin='normal' fullWidth variant='filled'>
					<InputLabel htmlFor='username'>Username</InputLabel>
					<FilledInput
						id='username'
						type='text'
						value={username}
						onChange={handleUserInput}
						ref={userRef}
						autoComplete='off'
						required
						endAdornment={
							<InputAdornment position='end'>
								<AccountCircle />
							</InputAdornment>
						}
					/>
				</FormControl>

				<FormControl margin='normal' fullWidth variant='filled'>
					<InputLabel htmlFor='password'>Password</InputLabel>
					<FilledInput
						id='password'
						type={showPassword ? 'text' : 'password'}
						value={password}
						onChange={handlePwdInput}
						required
						endAdornment={
							<InputAdornment position='end'>
								<IconButton
									aria-label='toggle password visibility'
									onClick={handleShowPassword}
									onMouseDown={handleMouseDownPassword}
									edge='end'
								>
									{showPassword ? <VisibilityOff /> : <Visibility />}
								</IconButton>
							</InputAdornment>
						}
					/>
				</FormControl>

				<Button fullWidth variant='contained' onClick={handleSubmit}>
					Sign In
				</Button>

				<div className='persistCheck'>
					<label className='form__label' htmlFor='persist'>
						Trust this device
						<input type='checkbox' id='persist' onChange={handleToggle} checked={persist} />
					</label>
				</div>
			</CardContent>
			{/* <p>
					Need an Account?
					<br />
					<span className='line'>
						<Link to={'/register'}>Sign Up</Link>
					</span>
				</p> */}
		</Card>
	)

	return content
}

export default Login
